import { useTheme } from "@emotion/react";

type Props = {
  tags: string[];
  size?: "default" | "compact";
  layout?: "wrap" | "inline";
  maxVisible?: number;
};

export const SupportTicketTags = ({ tags, size = "default", layout = "wrap", maxVisible }: Props) => {
  const theme = useTheme();

  if (tags.length === 0) {
    return null;
  }

  const visibleTags = maxVisible !== undefined ? tags.slice(0, maxVisible) : tags;
  const hiddenCount = maxVisible !== undefined ? Math.max(0, tags.length - maxVisible) : 0;

  const chipCss =
    size === "compact"
      ? {
          borderRadius: "1rem",
          background: theme.colors.primaryLight,
          padding: "0.125rem 0.5rem",
          color: theme.colors.primary,
          fontSize: "0.75rem",
          lineHeight: 1.4,
          whiteSpace: "nowrap" as const,
        }
      : {
          borderRadius: theme.smallBorderRadius,
          background: theme.colors.primaryLight,
          padding: "5px 10px",
          color: theme.colors.primary,
          lineHeight: 1.4,
          whiteSpace: "nowrap" as const,
        };

  const isInline = layout === "inline";

  return (
    <div
      css={{
        display: "flex",
        gap: size === "compact" ? "0.375rem" : "7px",
        flexWrap: isInline ? "nowrap" : "wrap",
        alignItems: "center",
        flexShrink: isInline ? 0 : undefined,
        overflow: isInline ? "hidden" : undefined,
      }}
    >
      {visibleTags.map((tag) => (
        <span key={tag} css={chipCss}>
          {`#${tag}`}
        </span>
      ))}
      {hiddenCount > 0 && (
        <span
          css={{
            ...chipCss,
            color: theme.colors.secondaryText,
            background: theme.colors.hover,
          }}
        >
          {`+${hiddenCount}`}
        </span>
      )}
    </div>
  );
};
